import TreasuryFormEditor from "../components/TreasuryFormEditor";

export default function TesoreriaFormulariosCrearPage() {
  return <TreasuryFormEditor mode="create" />;
}
